









































































































































module.exports =
  name: 'payment'
  metaInfo:
    title: '❤️'
  data: ->
    loading: false
    success_modal: false
    error_modal: false
    plan: null
    stripe_info: {}
  computed:
    have_subscription: -> @stripe_info.status == 'active'
    have_invoices: -> @stripe_info.invoices && @stripe_info.invoices.length > 0
  mounted: ->
    HM.track("page-payment", { days_till_end: HM.store.getters.days_till_end })
    $('.stripe_script').each (_, el) ->
      script = $( $(el).html().replace(/div/g, 'script') )
      $(el).html script
    @getSubscriptionInfo()
  methods:
    getSubscriptionInfo: ->
      promise = HM_API.stripe_info()
      @loading = true
      promise.then (res) =>
        @loading = false
        @stripe_info = res.data
    configureStripe: ->
      StripeCheckout.configure
        key: (if HM.is_production then 'pk_live_KOReuI2jBISrG9S3SRIb36Hc' else 'pk_test_6S4H16cjwgECgsG9KY8460Cs') # HoneyMoney.io code
        image: require('assets/bees/round_thumbs_up.png')
        locale: 'auto'
        currency: "usd"
        name: 'HoneyMoney'
        email: @$store.state.user.userdata.email
        token: (token) =>
          @loading = true
          promise = HM_API.create_subscription(@plan, token.id)
          promise.then (res) =>
            @loading = false
            if res.status == 'success'
              HM.track "user-subscribed", { plan: @plan }
              HM.store.state.user.userdata.paid_till = res.data.paid_till
              @success_modal = true
              @getSubscriptionInfo()
            if res.status == 'failure'
              @error_modal = true
              @error = res.error
          promise.catch =>
            @loading = false
            @error_modal = true
    stripeMonthly: ->
      @plan = 'monthly1'
      @configureStripe().open
        amount: 500
        description: 'Monthly Plan'
        panelLabel: 'Subscribe ({{amount}} / month)'
    stripeAnnual: ->
      @plan = 'yearly1'
      @configureStripe().open
        amount: 5000
        description: 'Annual Plan'
        panelLabel: 'Subscribe ({{amount}} / year)'
    updateCardDetails: ->
      @configureStripe().open
        panelLabel: 'Update Card Details'
        allowRememberMe: false
        token: (token) =>
          @loading = true
          promise = HM_API.update_card(token.id)
          promise.then (res) =>
            @loading = false
            if res.status == 'success'
              HM.track "user-update-card"
              @$message.success @$t('Done')
              @getSubscriptionInfo()
            if res.status == 'failure'
              @$message.danger res.error
          promise.catch =>
            @loading = false
            @$message.danger 'Something went wrong'

